import React, { useState } from 'react';

export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === 'admin' && password === 'Vaibhav@130522') {
      onLogin();
    } else {
      alert('Invalid credentials');
    }
  };

  return (
    <form onSubmit={handleLogin} style={{ maxWidth: 300, margin: '100px auto', textAlign: 'center' }}>
      <img src="/icon.png" alt="App Logo" style={{ width: 100, marginBottom: 20 }} />
      <h2>Admin Login</h2>
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={e => setUsername(e.target.value)}
        style={{ width: '100%', marginBottom: 10, padding: 8 }}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        style={{ width: '100%', marginBottom: 10, padding: 8 }}
      />
      <button type="submit" style={{ width: '100%', padding: 8 }}>Login</button>
    </form>
  );
}